import { useIntl } from 'react-intl'
import { useSelector } from 'react-redux';
import { formatChartDate, getBoundaryTimestamps } from '@/shared/utils/dateFormatters';
import { useGetEarningsStatsQuery } from '@/shared/api/Stats';
import {selectDateRange, selectPollingInterval} from "@/processes/Settings";
import CombinedLineChart from '@/shared/ui/charts/CombinedLineChart';
import { useMinerAccount } from "@/processes/MinerAccounts";

type PayoutsIncomeChartProps = {
  className?: string;
}

const PayoutsIncomeChart = (props: PayoutsIncomeChartProps) => {
  const { className } = props;
  const intl = useIntl();
  const pollingInterval = useSelector(selectPollingInterval);
  const dateRange = useSelector(selectDateRange);
  const { account, miner, coin } = useMinerAccount();

  const { data: earningStats, isSuccess } = useGetEarningsStatsQuery({
    miner,
    coin,
    account,
  }, { pollingInterval, skip: !coin })

  return (
    <>
      <CombinedLineChart
        isLoading={!isSuccess}
        className="w-full h-[220px] mt-6"
        data={earningStats}
        XAxisProps={{
          dataKey: 'timestamp',
          formatter: (value) => formatChartDate({ date: value, locale: intl.locale, dateRange, ...getBoundaryTimestamps(earningStats) }),
        }}
        YAxisProps={{
          dataKey: 'reward',
          width: 60,
        }}
        tooltipLabelFormatter={(value) => formatChartDate({ date: value, locale: intl.locale })}
        lines={[
          {
            name: intl.formatMessage({ id: 'payouts.income' }),
            dataKey: "reward",
            type: 'AREA',
            fill: 'secondary',
            stroke: "#7957FF",
          },
          {
            name: intl.formatMessage({ id: 'payouts.mean.income' }),
            dataKey: "meanReward",
            type: 'LINE',
            stroke: 'transparent',
            dot: false,
          },
        ]}
        tooltipLabelColors={{
          reward: '#7957FF',
          meanReward: '#f1a920'
        }}
      />
    </>
  );
}

export default PayoutsIncomeChart;
